module.exports = __webpack_public_path__ + "static/img/empty2.b9e38d9.png";